"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    confirmNewChampions: function() {
        return confirmNewChampions;
    },
    createReign: function() {
        return createReign;
    },
    deleteReign: function() {
        return deleteReign;
    },
    duplicateReign: function() {
        return duplicateReign;
    },
    endReign: function() {
        return endReign;
    },
    generateReigns: function() {
        return generateReigns;
    },
    resetReigns: function() {
        return resetReigns;
    },
    startReign: function() {
        return startReign;
    },
    updateReign: function() {
        return updateReign;
    }
});
const _types = /*#__PURE__*/ _interop_require_wildcard(require("./types/index.js"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function createReign(payload) {
    return {
        type: _types.ADD_REIGN,
        payload
    };
}
function duplicateReign(payload) {
    return {
        type: _types.DUPLICATE_REIGN,
        payload
    };
}
function updateReign(payload) {
    return {
        type: _types.UPDATE_REIGN,
        payload
    };
}
function generateReigns(payload) {
    return {
        type: _types.GENERATE_REIGNS,
        payload
    };
}
function deleteReign(payload) {
    return {
        type: _types.DELETE_REIGN,
        payload
    };
}
function resetReigns() {
    return {
        type: _types.RESET_REIGNS
    };
}
function endReign({ segmentId, championshipId, endDate }) {
    return {
        type: _types.UPDATE_REIGN,
        payload: {
            championshipId,
            segmentId,
            endDate
        }
    };
}
function startReign({ wrestlerIds, segmentId, championshipId, startDate }) {
    return {
        type: _types.CREATE_REIGN,
        payload: {
            wrestlerIds,
            championshipId,
            segmentId,
            startDate
        }
    };
}
function confirmNewChampions({ segmentId, championshipId, wrestlerIds = [], date = null }) {
    return {
        type: _types.NEW_CHAMPIONS,
        payload: {
            segmentId,
            championshipId,
            wrestlerIds,
            date
        }
    };
}
